/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OrderRouteImport } from './routes/_order'
import { Route as OrderListRouteImport } from './routes/_order-list'
import { Route as OrderListIndexRouteImport } from './routes/_order-list.index'
import { Route as OrderListOrdersCanceledRouteImport } from './routes/_order-list.orders.canceled'
import { Route as OrderListOrdersDeliveredRouteImport } from './routes/_order-list.orders.delivered'
import { Route as OrderListOrdersOnHoldRouteImport } from './routes/_order-list.orders.on-hold'
import { Route as OrderListOrdersPickedUpRouteImport } from './routes/_order-list.orders.picked-up'
import { Route as OrderListOrdersScheduledRouteImport } from './routes/_order-list.orders.scheduled'
import { Route as OrderListOrdersSubmittedRouteImport } from './routes/_order-list.orders.submitted'
import { Route as OrderOrdersOrderGuidRouteImport } from './routes/_order.orders.$orderGuid'
import { Route as OrderListReportsViewReportGuidRouteImport } from './routes/_order-list.reports.view.$reportGuid'
import { Route as OrderOrdersOrderGuidIndexRouteImport } from './routes/_order.orders.$orderGuid.index'
import { Route as OrderOrdersOrderGuidAttachmentsRouteImport } from './routes/_order.orders.$orderGuid.attachments'

const OrderRoute = OrderRouteImport.update({
  id: '/_order',
  getParentRoute: () => rootRouteImport,
} as any)
const OrderListRoute = OrderListRouteImport.update({
  id: '/_order-list',
  getParentRoute: () => rootRouteImport,
} as any)
const OrderListIndexRoute = OrderListIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrderListRoute,
} as any)
const OrderListOrdersCanceledRoute = OrderListOrdersCanceledRouteImport.update({
  id: '/orders/canceled',
  path: '/orders/canceled',
  getParentRoute: () => OrderListRoute,
} as any)
const OrderListOrdersDeliveredRoute =
  OrderListOrdersDeliveredRouteImport.update({
    id: '/orders/delivered',
    path: '/orders/delivered',
    getParentRoute: () => OrderListRoute,
  } as any)
const OrderListOrdersOnHoldRoute = OrderListOrdersOnHoldRouteImport.update({
  id: '/orders/on-hold',
  path: '/orders/on-hold',
  getParentRoute: () => OrderListRoute,
} as any)
const OrderListOrdersPickedUpRoute = OrderListOrdersPickedUpRouteImport.update({
  id: '/orders/picked-up',
  path: '/orders/picked-up',
  getParentRoute: () => OrderListRoute,
} as any)
const OrderListOrdersScheduledRoute =
  OrderListOrdersScheduledRouteImport.update({
    id: '/orders/scheduled',
    path: '/orders/scheduled',
    getParentRoute: () => OrderListRoute,
  } as any)
const OrderListOrdersSubmittedRoute =
  OrderListOrdersSubmittedRouteImport.update({
    id: '/orders/submitted',
    path: '/orders/submitted',
    getParentRoute: () => OrderListRoute,
  } as any)
const OrderOrdersOrderGuidRoute = OrderOrdersOrderGuidRouteImport.update({
  id: '/orders/$orderGuid',
  path: '/orders/$orderGuid',
  getParentRoute: () => OrderRoute,
} as any)
const OrderListReportsViewReportGuidRoute =
  OrderListReportsViewReportGuidRouteImport.update({
    id: '/reports/view/$reportGuid',
    path: '/reports/view/$reportGuid',
    getParentRoute: () => OrderListRoute,
  } as any)
const OrderOrdersOrderGuidIndexRoute =
  OrderOrdersOrderGuidIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OrderOrdersOrderGuidRoute,
  } as any)
const OrderOrdersOrderGuidAttachmentsRoute =
  OrderOrdersOrderGuidAttachmentsRouteImport.update({
    id: '/attachments',
    path: '/attachments',
    getParentRoute: () => OrderOrdersOrderGuidRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof OrderListIndexRoute
  '/orders/canceled': typeof OrderListOrdersCanceledRoute
  '/orders/delivered': typeof OrderListOrdersDeliveredRoute
  '/orders/on-hold': typeof OrderListOrdersOnHoldRoute
  '/orders/picked-up': typeof OrderListOrdersPickedUpRoute
  '/orders/scheduled': typeof OrderListOrdersScheduledRoute
  '/orders/submitted': typeof OrderListOrdersSubmittedRoute
  '/orders/$orderGuid': typeof OrderOrdersOrderGuidRouteWithChildren
  '/reports/view/$reportGuid': typeof OrderListReportsViewReportGuidRoute
  '/orders/$orderGuid/attachments': typeof OrderOrdersOrderGuidAttachmentsRoute
  '/orders/$orderGuid/': typeof OrderOrdersOrderGuidIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof OrderListIndexRoute
  '/orders/canceled': typeof OrderListOrdersCanceledRoute
  '/orders/delivered': typeof OrderListOrdersDeliveredRoute
  '/orders/on-hold': typeof OrderListOrdersOnHoldRoute
  '/orders/picked-up': typeof OrderListOrdersPickedUpRoute
  '/orders/scheduled': typeof OrderListOrdersScheduledRoute
  '/orders/submitted': typeof OrderListOrdersSubmittedRoute
  '/reports/view/$reportGuid': typeof OrderListReportsViewReportGuidRoute
  '/orders/$orderGuid/attachments': typeof OrderOrdersOrderGuidAttachmentsRoute
  '/orders/$orderGuid': typeof OrderOrdersOrderGuidIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_order': typeof OrderRouteWithChildren
  '/_order-list': typeof OrderListRouteWithChildren
  '/_order-list/': typeof OrderListIndexRoute
  '/_order-list/orders/canceled': typeof OrderListOrdersCanceledRoute
  '/_order-list/orders/delivered': typeof OrderListOrdersDeliveredRoute
  '/_order-list/orders/on-hold': typeof OrderListOrdersOnHoldRoute
  '/_order-list/orders/picked-up': typeof OrderListOrdersPickedUpRoute
  '/_order-list/orders/scheduled': typeof OrderListOrdersScheduledRoute
  '/_order-list/orders/submitted': typeof OrderListOrdersSubmittedRoute
  '/_order/orders/$orderGuid': typeof OrderOrdersOrderGuidRouteWithChildren
  '/_order-list/reports/view/$reportGuid': typeof OrderListReportsViewReportGuidRoute
  '/_order/orders/$orderGuid/attachments': typeof OrderOrdersOrderGuidAttachmentsRoute
  '/_order/orders/$orderGuid/': typeof OrderOrdersOrderGuidIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/orders/canceled'
    | '/orders/delivered'
    | '/orders/on-hold'
    | '/orders/picked-up'
    | '/orders/scheduled'
    | '/orders/submitted'
    | '/orders/$orderGuid'
    | '/reports/view/$reportGuid'
    | '/orders/$orderGuid/attachments'
    | '/orders/$orderGuid/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/orders/canceled'
    | '/orders/delivered'
    | '/orders/on-hold'
    | '/orders/picked-up'
    | '/orders/scheduled'
    | '/orders/submitted'
    | '/reports/view/$reportGuid'
    | '/orders/$orderGuid/attachments'
    | '/orders/$orderGuid'
  id:
    | '__root__'
    | '/_order'
    | '/_order-list'
    | '/_order-list/'
    | '/_order-list/orders/canceled'
    | '/_order-list/orders/delivered'
    | '/_order-list/orders/on-hold'
    | '/_order-list/orders/picked-up'
    | '/_order-list/orders/scheduled'
    | '/_order-list/orders/submitted'
    | '/_order/orders/$orderGuid'
    | '/_order-list/reports/view/$reportGuid'
    | '/_order/orders/$orderGuid/attachments'
    | '/_order/orders/$orderGuid/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  OrderRoute: typeof OrderRouteWithChildren
  OrderListRoute: typeof OrderListRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_order': {
      id: '/_order'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof OrderRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_order-list': {
      id: '/_order-list'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof OrderListRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_order-list/': {
      id: '/_order-list/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof OrderListIndexRouteImport
      parentRoute: typeof OrderListRoute
    }
    '/_order-list/orders/canceled': {
      id: '/_order-list/orders/canceled'
      path: '/orders/canceled'
      fullPath: '/orders/canceled'
      preLoaderRoute: typeof OrderListOrdersCanceledRouteImport
      parentRoute: typeof OrderListRoute
    }
    '/_order-list/orders/delivered': {
      id: '/_order-list/orders/delivered'
      path: '/orders/delivered'
      fullPath: '/orders/delivered'
      preLoaderRoute: typeof OrderListOrdersDeliveredRouteImport
      parentRoute: typeof OrderListRoute
    }
    '/_order-list/orders/on-hold': {
      id: '/_order-list/orders/on-hold'
      path: '/orders/on-hold'
      fullPath: '/orders/on-hold'
      preLoaderRoute: typeof OrderListOrdersOnHoldRouteImport
      parentRoute: typeof OrderListRoute
    }
    '/_order-list/orders/picked-up': {
      id: '/_order-list/orders/picked-up'
      path: '/orders/picked-up'
      fullPath: '/orders/picked-up'
      preLoaderRoute: typeof OrderListOrdersPickedUpRouteImport
      parentRoute: typeof OrderListRoute
    }
    '/_order-list/orders/scheduled': {
      id: '/_order-list/orders/scheduled'
      path: '/orders/scheduled'
      fullPath: '/orders/scheduled'
      preLoaderRoute: typeof OrderListOrdersScheduledRouteImport
      parentRoute: typeof OrderListRoute
    }
    '/_order-list/orders/submitted': {
      id: '/_order-list/orders/submitted'
      path: '/orders/submitted'
      fullPath: '/orders/submitted'
      preLoaderRoute: typeof OrderListOrdersSubmittedRouteImport
      parentRoute: typeof OrderListRoute
    }
    '/_order/orders/$orderGuid': {
      id: '/_order/orders/$orderGuid'
      path: '/orders/$orderGuid'
      fullPath: '/orders/$orderGuid'
      preLoaderRoute: typeof OrderOrdersOrderGuidRouteImport
      parentRoute: typeof OrderRoute
    }
    '/_order-list/reports/view/$reportGuid': {
      id: '/_order-list/reports/view/$reportGuid'
      path: '/reports/view/$reportGuid'
      fullPath: '/reports/view/$reportGuid'
      preLoaderRoute: typeof OrderListReportsViewReportGuidRouteImport
      parentRoute: typeof OrderListRoute
    }
    '/_order/orders/$orderGuid/': {
      id: '/_order/orders/$orderGuid/'
      path: '/'
      fullPath: '/orders/$orderGuid/'
      preLoaderRoute: typeof OrderOrdersOrderGuidIndexRouteImport
      parentRoute: typeof OrderOrdersOrderGuidRoute
    }
    '/_order/orders/$orderGuid/attachments': {
      id: '/_order/orders/$orderGuid/attachments'
      path: '/attachments'
      fullPath: '/orders/$orderGuid/attachments'
      preLoaderRoute: typeof OrderOrdersOrderGuidAttachmentsRouteImport
      parentRoute: typeof OrderOrdersOrderGuidRoute
    }
  }
}

interface OrderOrdersOrderGuidRouteChildren {
  OrderOrdersOrderGuidAttachmentsRoute: typeof OrderOrdersOrderGuidAttachmentsRoute
  OrderOrdersOrderGuidIndexRoute: typeof OrderOrdersOrderGuidIndexRoute
}

const OrderOrdersOrderGuidRouteChildren: OrderOrdersOrderGuidRouteChildren = {
  OrderOrdersOrderGuidAttachmentsRoute: OrderOrdersOrderGuidAttachmentsRoute,
  OrderOrdersOrderGuidIndexRoute: OrderOrdersOrderGuidIndexRoute,
}

const OrderOrdersOrderGuidRouteWithChildren =
  OrderOrdersOrderGuidRoute._addFileChildren(OrderOrdersOrderGuidRouteChildren)

interface OrderRouteChildren {
  OrderOrdersOrderGuidRoute: typeof OrderOrdersOrderGuidRouteWithChildren
}

const OrderRouteChildren: OrderRouteChildren = {
  OrderOrdersOrderGuidRoute: OrderOrdersOrderGuidRouteWithChildren,
}

const OrderRouteWithChildren = OrderRoute._addFileChildren(OrderRouteChildren)

interface OrderListRouteChildren {
  OrderListIndexRoute: typeof OrderListIndexRoute
  OrderListOrdersCanceledRoute: typeof OrderListOrdersCanceledRoute
  OrderListOrdersDeliveredRoute: typeof OrderListOrdersDeliveredRoute
  OrderListOrdersOnHoldRoute: typeof OrderListOrdersOnHoldRoute
  OrderListOrdersPickedUpRoute: typeof OrderListOrdersPickedUpRoute
  OrderListOrdersScheduledRoute: typeof OrderListOrdersScheduledRoute
  OrderListOrdersSubmittedRoute: typeof OrderListOrdersSubmittedRoute
  OrderListReportsViewReportGuidRoute: typeof OrderListReportsViewReportGuidRoute
}

const OrderListRouteChildren: OrderListRouteChildren = {
  OrderListIndexRoute: OrderListIndexRoute,
  OrderListOrdersCanceledRoute: OrderListOrdersCanceledRoute,
  OrderListOrdersDeliveredRoute: OrderListOrdersDeliveredRoute,
  OrderListOrdersOnHoldRoute: OrderListOrdersOnHoldRoute,
  OrderListOrdersPickedUpRoute: OrderListOrdersPickedUpRoute,
  OrderListOrdersScheduledRoute: OrderListOrdersScheduledRoute,
  OrderListOrdersSubmittedRoute: OrderListOrdersSubmittedRoute,
  OrderListReportsViewReportGuidRoute: OrderListReportsViewReportGuidRoute,
}

const OrderListRouteWithChildren = OrderListRoute._addFileChildren(
  OrderListRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  OrderRoute: OrderRouteWithChildren,
  OrderListRoute: OrderListRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
